import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { ActionSheet, translate, setActiveLanguage } from '@haldor/ui';
import { setPageTitle, setPageActions } from 'actions/header';

var Settings = /*#__PURE__*/function (_Component) {
  _inherits(Settings, _Component);

  var _super = _createSuper(Settings);

  function Settings() {
    var _this;

    _classCallCheck(this, Settings);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.props.setPageTitle(_this.props.translate('settings'));
    });

    _defineProperty(_assertThisInitialized(_this), "triggerLanguage", function () {
      var languages = [];
      languages.push({
        value: 'sv-se',
        label: _this.props.translate('swedish')
      });
      languages.push({
        value: 'en-us',
        label: _this.props.translate('english')
      });
      languages.push({
        value: 'da-dk',
        label: _this.props.translate('danish')
      });
      languages.push({
        value: 'nb-no',
        label: _this.props.translate('norwegian')
      });
      languages.push({
        value: 'uk',
        label: _this.props.translate('ukrainian')
      });
      ActionSheet.prompt({
        items: languages
      }).then(function (lang) {
        setActiveLanguage(lang);

        _this.props.history.push("/switch");
      });
    });

    return _this;
  }

  _createClass(Settings, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "menu-page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "items-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: this.triggerLanguage,
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("span", null, this.props.translate('select-language')))), /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container"
      }, /*#__PURE__*/React.createElement(Link, {
        to: '/logout',
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("span", {
        className: "color--blue"
      }, this.props.translate('log-out'))))));
    }
  }]);

  return Settings;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default withRouter(connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  setPageActions: setPageActions
})(Settings));